<ng-container [ngSwitch]="convertStatus">
    <ca-icon
        *ngSwitchCase="'NotCZI'"
        [name]="iconName"
        [ngClass]="marginClass"
        [class]="iconColorClass"
        [ngbTooltip]="conversionTooltip"
        container="body"
        size="s"
    ></ca-icon>
    <ca-icon
        *ngSwitchCase="'Active'"
        [name]="iconName"
        [ngClass]="marginClass"
        [class]="iconColorClass"
        [ngbTooltip]="conversionTooltip"
        container="body"
        size="s"
        data-uit="active-icon"
    ></ca-icon>
    <ca-icon
        *ngSwitchCase="'Failed'"
        [name]="iconName"
        [ngClass]="marginClass"
        [class]="iconColorClass"
        [ngbTooltip]="conversionTooltip"
        container="body"
        size="s"
        data-uit="failed-icon"
    ></ca-icon>
    <ng-container *ngSwitchCase="'Success'">
        <ng-container *ngIf="!shouldShowValidationStatus && !isSegmentation; else validationStatusContainer">
            <ca-icon name="checkmark" size="m" [ngClass]="marginClass" class="ca-color-success" data-uit="conversion-success-icon"></ca-icon>
        </ng-container>
        <ng-template #validationStatusContainer>
            <ng-container [ngSwitch]="validationStatus">
                <ca-icon *ngSwitchCase="'Valid'" name="checkmark" size="m" class="ca-color-success me-3" data-uit="valid-icon"></ca-icon>
                <ca-icon
                    *ngSwitchCase="'ChannelStructureMismatch'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'InvalidFileFormat'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'InvalidPixelType'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'InvalidBitDepth'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'Unknown'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'UnsupportedDimensions'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'XYDimensionsTooSmall'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                    data-uit="invalid-icon"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'InvalidAmlModelVersion'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                    data-uit="invalid-icon"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'MetadataAbsent'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'InvalidWithoutReason'"
                    name="error_outline"
                    size="s"
                    class="ca-color-icon-error me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ca-icon
                    *ngSwitchCase="'PendingValidation'"
                    data-uit="validation-active-icon"
                    name="loading"
                    size="s"
                    class="me-3"
                    [ngbTooltip]="validationTooltip"
                    container="body"
                ></ca-icon>
                <ng-container *ngSwitchDefault>
                    <ca-icon name="checkmark" size="m" class="ca-color-success me-3"></ca-icon>
                </ng-container>
            </ng-container>
        </ng-template>
    </ng-container>
    <!-- Default case for unknown conversion statuses e.g. where conversion is not enabled and files can be freely added-->
    <ng-container *ngSwitchDefault>
        <ca-icon name="checkmark" size="m" class="ca-color-success me-3"></ca-icon>
    </ng-container>
</ng-container>
